import { Path, Svg } from 'react-native-svg';
import { IconProps } from './types';

export const IconCheck = ({ width = 16, height = 12, color }: IconProps) => (
  <Svg width={width} height={height} viewBox="0 0 16 12">
    <Path
      fill={color}
      d="M3.35391 5.29352L3.35391 5.29352L3.35267 5.29228C3.09523 5.03484 2.77131 4.89583 2.40536 4.89583C2.03942 4.89583 1.7155 5.03484 1.45806 5.29228C1.20413 5.54621 1.06235 5.86406 1.05143 6.22444C1.04018 6.59571 1.17617 6.92582 1.43723 7.18689L5.02056 10.7702C5.27468 11.0243 5.59395 11.1667 5.95745 11.1667C6.32095 11.1667 6.64021 11.0243 6.89433 10.7702L14.561 3.10355C14.8184 2.84611 14.9574 2.5222 14.9574 2.15625C14.9574 1.7903 14.8184 1.46639 14.561 1.20895C14.3036 0.951504 13.9796 0.8125 13.6137 0.8125C13.2478 0.8125 12.9238 0.951504 12.6664 1.20895L5.95869 7.91665L3.35391 5.29352Z"
    />
  </Svg>
);
